export default {
  SET_SELECTED_TOPIC(state, payload) {
    console.log(payload);
    state.selectedTopic = payload;
  }
};
